module.exports = __webpack_public_path__ + "img/iMac24inch@2x.f6b48e5f.webp";